import { defineComponent as _defineComponent } from 'vue';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
// @ts-ignore
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-sql';
import 'prismjs/themes/prism-tomorrow.css';
import "codemirror/addon/display/autorefresh.js";
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/sql/sql.js';
import 'codemirror/theme/solarized.css';
import { computed, ref } from 'vue';
import { useActions } from 'vuex-composition-helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AICodeField',
    props: {
        value: null,
        defaultPrompt: null,
        feedId: null
    },
    emits: ["blur", "input", "save"],
    setup(__props, { emit }) {
        const props = __props;
        const code = computed({
            get() {
                return props.value;
            },
            set(value) {
                emit('input', value || '');
            },
        });
        const cmOptions = {
            tabSize: 4,
            mode: 'text/x-mysql',
            theme: 'solarized light',
            lineNumbers: true,
            line: true,
            lineWrapping: true,
            autoRefresh: true
        };
        const waitingAIResponse = ref(false);
        const backupCode = ref(null);
        const aiPrompt = ref('');
        function highlighter(code) {
            return highlight(code, languages.sql); // languages.<insert language> to return html with markup
        }
        function restoreBackupCode() {
            emit('input', backupCode.value || '');
            backupCode.value = null;
        }
        const { create: promptAI } = useActions('ai-query-helper', ['create']);
        async function runAI() {
            backupCode.value = code.value || '';
            waitingAIResponse.value = true;
            code.value = await promptAI({
                feedId: props.feedId,
                message: aiPrompt.value,
            }).then((response) => response.message.replace(/```(sql)?/g, '')).finally(() => waitingAIResponse.value = false);
            emit('save');
        }
        return { __sfc: true, props, emit, code, cmOptions, waitingAIResponse, backupCode, aiPrompt, highlighter, restoreBackupCode, promptAI, runAI, PrismEditor };
    }
});
